var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertMonoColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1758 8.23531L1.88226 10.1177L6.19836 2.17567C6.8923 0.898763 8.70995 0.856531 9.46244 2.09983L13.1758 8.23531Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58795 11.1177C6.58795 10.4172 7.13153 9.84928 7.80207 9.84928C8.47261 9.84928 9.01619 10.4172 9.01619 11.1177C9.01619 11.8182 8.47261 12.386 7.80207 12.386C7.13153 12.386 6.58795 11.8182 6.58795 11.1177Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84516 9.04011L6.64937 5.29011C6.63947 5.10057 6.7839 4.94119 6.9656 4.94119H8.63852C8.82022 4.94119 8.96467 5.10057 8.95477 5.29011L8.75898 9.04011C8.74982 9.21559 8.61094 9.35296 8.44273 9.35296H7.16141C6.9932 9.35296 6.85432 9.21559 6.84516 9.04011Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03304 2.64038C8.45875 1.6074 7.00709 1.63503 6.47207 2.69363L1.81618 11.9057C1.29539 12.9361 2.03972 14.1177 3.11079 14.1177H12.8881C13.9842 14.1177 14.7283 12.8845 14.1545 11.8525L9.03304 2.64038ZM5.21216 2.05679C6.25662 -0.00976899 9.14099 -0.0707693 10.2669 1.95437L15.3883 11.1664C16.4583 13.0909 15.1159 15.5294 12.8881 15.5294H3.11079C0.9344 15.5294 -0.41489 13.1904 0.556275 11.2689L5.21216 2.05679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMonoColor);
export default __webpack_public_path__ + "static/media/alert-mono-color.7ed0264eb5cbb767f8a2fd5e59c182a1.svg";
export { ForwardRef as ReactComponent };